import {
  AppstoreOutlined,
  FieldTimeOutlined,
} from "@ant-design/icons";
import { FC } from "react";
import "./index.css";

export type ProjectFlowViewMode = "matrix" | "timeline";

interface ProjectFlowModeSwitchProps {
  mode: ProjectFlowViewMode;
  onChange: (mode: ProjectFlowViewMode) => void;
  disabled?: boolean;
}

const ProjectFlowModeSwitch: FC<ProjectFlowModeSwitchProps> = ({
  mode,
  onChange,
  disabled = false,
}) => {
  const options: Array<{
    mode: ProjectFlowViewMode;
    label: string;
    icon: JSX.Element;
  }> = [
    { mode: "matrix", label: "任务模块", icon: <AppstoreOutlined /> },
    { mode: "timeline", label: "时间线", icon: <FieldTimeOutlined /> },
  ];

  return (
    <div className={`projectFlowModeSwitch projectFlowModeSwitch--${mode}`}>
      <div className="projectFlowModeSwitch__segments">
        {options.map((option) => {
          return (
            <button
              aria-label={`${option.label}模式`}
              className={mode === option.mode ? "is-active" : ""}
              disabled={disabled}
              key={option.mode}
              onClick={() => onChange(option.mode)}
              title={`${option.label}模式`}
              type="button"
            >
              {option.icon}
              <span>{option.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ProjectFlowModeSwitch;
